(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var ListView = require('../views/list')
  , FormView = require('../views/form')
  , OfficeCollection = require('../collections/office')
  , OfficeModel = require('../models/office')
  , debug = require('../../../../admin/source/js/app/lib/debug')('router')

module.exports = function (serviceLocator) {
  var router = serviceLocator.router
    , collection = new OfficeCollection()
    , displayName = { singular: 'Office', plural: 'Offices' }

  router.route('offices(/)', 'listOffices', function () {

    debug('office url list view route triggered')
    if (!serviceLocator.allow('office', 'read')) {
      return false
    }

    var listView = new ListView(
      { collection: collection
      , serviceLocator: serviceLocator
      , displayName: displayName
      })

    listView.on('new'
      , router.navigate.bind(router, 'offices/form', { trigger: true }))

    listView.on('edit', function (model) {
      router.navigate('offices/' + model.id + '/form', { trigger: true })
    })

    router.render(listView, displayName.plural)

    collection.reset([])
    collection.applyFilter(listView.filters.getSavedParams())
  })

  router.route('offices/form(/)', 'newOffice', function () {
    if (!serviceLocator.allow('office', 'create')) {
      return false
    }
    debug('office create view route triggered')
    var model = new OfficeModel({}, { collection: collection })
      , view = new FormView(
        { model: model
        , title: displayName.singular
        , serviceLocator: serviceLocator
        , isNew: true
        })

    view.on('save cancel', function () {
      router.navigate('offices', { trigger: true })
    })

    router.render(view, displayName.plural)
  })

  router.route('offices/:id/form(/)', 'editOffice', function (id) {
    if (!serviceLocator.allow('office', 'update')) {
      return false
    }
    debug('office edit view route triggered')

    collection.retrieve(id, function (err, model) {

      if (err) {
        router.trigger('notFound', err.message)
        return
      }
      debug('Loading form view', model)
      var view = new FormView({ model: model, title: displayName.singular
      , serviceLocator: serviceLocator })

      view.on('cancel', function () {
        router.navigate('offices', { trigger: true })
      })

      router.render(view, displayName.plural)
    })
  })
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/office/controllers/controller.js","/components/admin/office/controllers")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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